import { render, staticRenderFns } from "./textView.vue?vue&type=template&id=b46c7730"
import script from "./textView.vue?vue&type=script&lang=js"
export * from "./textView.vue?vue&type=script&lang=js"
import style0 from "./textView.vue?vue&type=style&index=0&id=b46c7730&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports